import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { PageTitles } from "constants";
import EditFeedbackForm from "./EditFeedbackForm";

export default function EditFeedbackFormDetails() {
    return (
        <div className="page-content">
            <Helmet>
                <title>{PageTitles.EDIT_FEEDBACK_FORM}</title>
            </Helmet>
            <Container fluid className="customer-details">
                <EditFeedbackForm />
            </Container>
        </div>
    );
}
